import React, {useEffect, useImperativeHandle, useRef, useState} from 'react';
import {PopoverBody, UncontrolledPopover} from 'reactstrap';
import {useLocation} from 'react-router-dom';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';

import {isEmptyObject} from '../../../../helpers';
import {Input} from '../../../../components/atoms';
import {strings} from '../../../../assets';
import {Mask} from '@tboerc/maskfy';

const CALLER = 'SEGURADO_BASIC';

const INITIAL_VALUES = {
  nome: '',
  email: '',
  telefone: '',
  data_nasc: '',
  terms: false,
  nome_social: '',
};

const Segurado_basic = ({position, current, checkAdvance, corPrimaria, modalAtual}) => {
  const location = useLocation();
  const corretor = location.search;
  const isCostumer = !!corretor;
  const sizeRef = useRef();
  const [campanhaRespondida, setCampanhaRespondida] = useState(false);
  const [respostaNomeSocial, setRespostaNomeSocial] = useState(false);

  useImperativeHandle(ref, () => ({
    values: () => ({caller: CALLER, data: {...values}}),
    ref: sizeRef,
  }));

  const name = useRef();
  const nome_social = useRef();
  const email = useRef();
  const phone = useRef();
  const data_nasc = useRef();

  const validationSchema = Yup.object().shape({
    nome: Yup.string().required(strings.required),
    email: Yup.string().email('E-mail inválido.').required(strings.required),
    telefone: Yup.string().min(15, 'Preencha corretamente.').required(strings.required),
    data_nasc: Yup.string()
      .test('DOB', 'Preencha corretamente', (value) => {
        if (dayjs().diff(dayjs(value, 'DD/MM/YYYY'), 'years') >= 18 && dayjs().diff(dayjs(value, 'DD/MM/YYYY'), 'years') < 100) {
          return true;
        }
      })
      .required(strings.required),
    terms: Yup.boolean().notOneOf([false]).required(),
    nome_social: respostaNomeSocial ? Yup.string().min(2).required(strings.required) : Yup.string(),
  });

  const {handleChange, handleBlur, setFieldValue, setValues, errors, touched, values} = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema,
    initialErrors: strings.INITIAL_ERRORS,
  });

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: isEmptyObject(errors)});
  });

  /*  const Campanha = useCallback(async () => {
    if (modalAtual === 0 && !campanhaRespondida) {
      const resp = await swal({
        title: 'Campanhar Tour de France 2023',
        text: 'Desconto: 10%OFF.\n Deseja usar o cupom:  "TOURDEFRANCE".\n Válido somente para cotações com uma bike.',
        icon: 'info',
        buttons: ['Declinar', 'Confirmar'],
      });
      if (resp)
        setValues({
          ...values,
          is_campaign: 2,
          cupom: {
            code: 'TOURDEFRANCE',
            id_cupom: 178,
            tipo_desconto: 0,
            valor_desconto: 10.0,
          },
        });

      if (resp === null) {
        setValues({
          ...values,
          is_campaign: 3,
        });
      }

      setCampanhaRespondida(true);
    }
  }, [modalAtual]);

  const RemoveCampanha = useCallback(async () => {
    if (modalAtual !== 0 && campanhaRespondida) {
      setValues({
        ...values,
        is_campaign: 0,
        cupom: {
          code: '',
          id_cupom: null,
          tipo_desconto: '',
          valor_desconto: '',
        },
      });
      setCampanhaRespondida(false);
    }
  }, [modalAtual]);

  useEffect(() => {
    if (modalAtual === 0) Campanha();
    if ((modalAtual === 1 || modalAtual === 2 || modalAtual === 3) && campanhaRespondida) RemoveCampanha();
  }, [modalAtual]); */

  return (
    <form className="formStep" ref={sizeRef}>
      <div className="controlForms">
        <div className="leftSide">
          {isCostumer ? (
            <>
              <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Seus dados</h1>
              <p>Insira seus dados para iniciar o cadastro.</p>
            </>
          ) : (
            <>
              <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Dados do cliente</h1>
              <p>Insira os dados do cliente para iniciar o cadastro. Esses dados não devem ser divulgados.</p>
            </>
          )}
        </div>

        <div className="rightSide">
          <div className="formGroup">
            <div className="group">
              <label>Nome completo</label>
              <Input
                ref={name}
                placeholder="Digite o nome completo"
                nextTabRef={email}
                name="nome"
                value={values.nome}
                onChangeText={handleChange('nome')}
                onBlur={handleBlur('nome')}
                error={errors.nome && touched.nome}
              />
              {errors?.nome && <small className={'text-danger errorInput'}>{errors?.nome}</small>}
            </div>

            <div className="group">
              <label>E-mail</label>
              <Input
                ref={email}
                inputMode="email"
                placeholder="Digite o seu e-mail de acesso"
                nextTabRef={phone}
                name="email"
                type="email"
                value={values.email}
                onChangeText={handleChange('email')}
                error={errors.email && touched.email}
              />
              {errors?.email && <small className={'text-danger errorInput'}>{errors?.email}</small>}
            </div>

            <div className="group">
              <label>Telefone</label>
              <Input
                ref={phone}
                placeholder="(--) - ----_----"
                type="tel"
                inputMode="numeric"
                nextTabRef={data_nasc}
                name="telefone"
                value={values.telefone}
                onChangeText={handleChange('telefone')}
                onBlur={handleBlur('telefone')}
                error={errors.telefone && touched.telefone}
                formatText={Mask.phone.value}
              />
              {errors?.telefone && <small className={'text-danger errorInput'}>{errors?.telefone}</small>}
            </div>

            <div className="group">
              <label>Data de nascimento</label>
              <Input
                placeholder="Data de nascimento"
                ref={data_nasc}
                nextTabRef={name}
                name="data_nasc"
                type={'text'}
                inputMode="numeric"
                value={values.data_nasc}
                formatText={(e) => Mask.custom.value(e, '99/99/9999')}
                onChangeText={handleChange('data_nasc')}
                onBlur={handleBlur('data_nasc')}
                error={errors.data_nasc && touched.data_nasc}
              />
              {errors?.data_nasc && <small className={'text-danger errorInput'}>{errors?.data_nasc}</small>}
            </div>

            <div className="radioGroup">
              <div className="radioHeader">
                <p>
                  Nome social? (
                  <a id="UncontrolledPopover" style={{cursor: 'pointer'}}>
                    Saiba mais
                  </a>
                  )
                </p>
              </div>
              <UncontrolledPopover placement="bottom" target="UncontrolledPopover">
                <PopoverBody>
                  Campo exclusivo para nome social: Entende-se por nome social a identificação que o indivíduo escolheu para lhe
                  representar diante dos demais, por entender que o nome constante em seus registros oficiais não condiz com sua
                  personalidade e identidade de gênero.
                </PopoverBody>
              </UncontrolledPopover>
              <div className="radioFields">
                <input
                  tabIndex={-1}
                  type="radio"
                  value={true}
                  checked={respostaNomeSocial === true ? true : false}
                  name="respostaNomeSocial"
                  id="yes"
                  onClick={() => setRespostaNomeSocial(true)}
                  onChange={() => {}}
                  style={{marginLeft: -8}}
                />
                <label htmlFor="yes">Sim</label>
                <input
                  tabIndex={-1}
                  type="radio"
                  value={false}
                  checked={respostaNomeSocial === true ? false : true}
                  name="respostaNomeSocial"
                  id="not"
                  onClick={() => setRespostaNomeSocial(false)}
                  onChange={() => {}}
                  style={{marginLeft: -55}}
                />
                <label htmlFor="not">Não</label>
              </div>
            </div>

            {respostaNomeSocial && (
              <div className="group">
                <Input
                  ref={nome_social}
                  placeholder="Digite o nome social"
                  nextTabRef={email}
                  name="nome_social"
                  value={values.nome_social}
                  onChangeText={handleChange('nome_social')}
                  onBlur={handleBlur('nome_social')}
                  error={errors.nome_social && touched.nome_social}
                />
                {errors?.nome_social && <small className={'text-danger errorInput'}>{errors?.nome_social}</small>}
              </div>
            )}
            <div className="group mt-3">
              <label>Sexo</label>
              <div>
                <input name="sexo" id="sexoM" type="radio" onChange={() => setFieldValue('sexo', 'M')} />
                <label htmlFor="sexoM" className="ml-1">
                  Masculino
                </label>
                <input name="sexo" id="sexoF" className="ml-3" type="radio" onChange={() => setFieldValue('sexo', 'F')} />
                <label htmlFor="sexoF" className="ml-1">
                  Feminino
                </label>
                <input name="sexo" id="sexoO" className="ml-3" type="radio" onChange={() => setFieldValue('sexo', 'O')} />
                <label htmlFor="sexoO" className="ml-1">
                  Outros
                </label>
              </div>
            </div>

            <div className="mt-3">
              <input name="terms" id="terms" type="checkbox" onChange={() => setFieldValue('terms', !values.terms)} />
              <label htmlFor="terms" className="ml-2">
                Aceitar{' '}
                <a href="https://bicisura.com.br/termos_sura.html" target="blank">
                  Termos de acordo
                </a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default React.memo(Segurado_basic);
export const ref = React.createRef();
